export default __webpack_public_path__ + "static/TragicMarker-cb38d19ef1f5c35a2cd8c8ce3487703e.eot";